import { PassedInitialConfig } from 'angular-auth-oidc-client';

import { environment } from '../../environments/environment';

export const authConfig: PassedInitialConfig = {
  config: environment.auth,
};
